import type { ConnectionHealth, HealthState } from '../../lib/health-api';
import styles from './admin.module.css';

const BADGE: Record<HealthState, string> = {
  healthy: styles.healthHealthy!,
  degraded: styles.healthDegraded!,
  down: styles.healthDown!,
  disabled: styles.healthDisabled!,
};

export function HealthBadge({ state }: { state: HealthState }) {
  return <span className={`${styles.healthBadge} ${BADGE[state]}`}>{state}</span>;
}

export function IssueList({ health }: { health: ConnectionHealth }) {
  if (health.issues.length === 0) return null;
  return (
    <ul className={styles.issueList}>
      {health.issues.map((i) => (
        <li key={i.code} className={i.severity === 'critical' ? styles.issueCritical : undefined}>
          {i.message}
          {i.action && <span style={{ opacity: 0.8 }}> — {i.action}</span>}
        </li>
      ))}
    </ul>
  );
}

export function SummaryChips({ summary }: { summary: Record<HealthState, number> }) {
  return (
    <div className={styles.healthSummary}>
      {(['down', 'degraded', 'healthy', 'disabled'] as const).map((s) => (
        <span key={s}>
          <HealthBadge state={s} /> {summary[s]}
        </span>
      ))}
    </div>
  );
}

export const fmtTime = (iso: string | null) => (iso ? new Date(iso).toLocaleString() : '—');

export function fmtDuration(sec: number): string {
  if (sec < 90) return `${sec}s`;
  if (sec < 5400) return `${Math.round(sec / 60)}m`;
  if (sec < 172800) return `${Math.round(sec / 3600)}h`;
  return `${Math.round(sec / 86400)}d`;
}
